export const ALL_ORG_CONTEXT_ID = -1;
export const PRIMARY_ORG_CONTEXT_ID = 0;
export const ALL_ORG_VIEW_MODE = 'all-org';
export const PRIMARY_ORG_VIEW_MODE = 'primary-org';
export const SPECIFIC_ORG_VIEW_MODE = 'none-org';
export const resolveEffectiveAdminOrgId = ({ currentOrgId, sessionOrgId, orgUiEnabled, orgViewModeType, }) => {
    if (!orgUiEnabled) {
        return currentOrgId ?? sessionOrgId;
    }
    if (orgViewModeType === ALL_ORG_VIEW_MODE) {
        return ALL_ORG_CONTEXT_ID;
    }
    if (orgViewModeType === PRIMARY_ORG_VIEW_MODE) {
        return PRIMARY_ORG_CONTEXT_ID;
    }
    if (orgViewModeType) {
        if (sessionOrgId !== undefined &&
            sessionOrgId > PRIMARY_ORG_CONTEXT_ID) {
            return sessionOrgId;
        }
        if (currentOrgId !== undefined &&
            currentOrgId > PRIMARY_ORG_CONTEXT_ID) {
            return currentOrgId;
        }
        return undefined;
    }
    return currentOrgId ?? sessionOrgId;
};
export const resolveAdminOrgContext = ({ effectiveCurrentOrgId, orgUiEnabled, orgViewModeType, }) => {
    if (!orgUiEnabled) {
        return {
            isAllOrgContext: false,
            isPrimaryOrgContext: false,
            isSpecificOrgContext: false,
            isOrgScopedContext: false,
        };
    }
    if (orgViewModeType === ALL_ORG_VIEW_MODE) {
        return {
            isAllOrgContext: true,
            isPrimaryOrgContext: false,
            isSpecificOrgContext: false,
            isOrgScopedContext: false,
        };
    }
    if (orgViewModeType === PRIMARY_ORG_VIEW_MODE) {
        return {
            isAllOrgContext: false,
            isPrimaryOrgContext: true,
            isSpecificOrgContext: false,
            isOrgScopedContext: true,
        };
    }
    if (orgViewModeType === SPECIFIC_ORG_VIEW_MODE) {
        return {
            isAllOrgContext: false,
            isPrimaryOrgContext: false,
            isSpecificOrgContext: true,
            isOrgScopedContext: true,
        };
    }
    const resolvedOrgId = effectiveCurrentOrgId ?? PRIMARY_ORG_CONTEXT_ID;
    const isAllOrgContext = resolvedOrgId === ALL_ORG_CONTEXT_ID;
    const isPrimaryOrgContext = !isAllOrgContext && resolvedOrgId === PRIMARY_ORG_CONTEXT_ID;
    return {
        isAllOrgContext,
        isPrimaryOrgContext,
        isSpecificOrgContext: !isAllOrgContext && resolvedOrgId > PRIMARY_ORG_CONTEXT_ID,
        isOrgScopedContext: !isAllOrgContext && resolvedOrgId >= PRIMARY_ORG_CONTEXT_ID,
    };
};
//# sourceMappingURL=admin-org-context.js.map